var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CourseSearchPage',{attrs:{"filter-fields":_vm.filterFields}})}
var staticRenderFns = []

export { render, staticRenderFns }